// import { StudyImageInfos } from "../study.model";

import { AiRequestlogModal } from "../study.model";
import { StudyImageInfo } from "./study-image-infos.model";

// export class OpenAiModel {
//     UserId?: number;
//     OrderId?: number;
//     AccessionNo: string;
//     AiModel: string;
//     PromptText: string;
//     ReportText: string;
//     // StudyImageInfos: StudyImageInfos[] = [];
//     SelectedImageNames: string[];
//     AIResponseResult: string = '';
// }

export class OpenAiModel {
  OrderId?: number;
  AccessionNo: string;
  AiModel: string;
  ModelId?: number;
  AIRole: string;
  RoleId: number;
  PromptText: string;
  ReportText: string;
  DisplayPrompt: string;
  AIResponseResult: string = "";
  AiResponsemodified: string = "";
  UserId?: number;
  ReportFullPath: string;
  OrderIds: number[];
  HistoryOrderIds: number[];
  StudyImageInfos: StudyImageInfo[];
  StudyHistoryImageInfos: StudyImageInfo[];
  aiRequestlogList: AiRequestlogModal[];
}
